<div class="row">
  <div class="col-6">
    <h3 class="heading">
      {{ !!user.fullName ? user.fullName : user.username }} - <em>{{ user.status | replace: '_':' ' | titlecase }}</em>
      @if (user.cognitoDisabled && user.status !== userStatuses.disabled) {
        (Cognito Disabled)
      }
    </h3>
  </div>
  <div class="col-6 text-end"><ng-content /></div>
</div>
